export class Country {
  name: string = "";
  dialCode: string = "";
  code: string = "";
  dialCodeTitle: string = "";

  constructor(name: string, dialCode: string, code: string) {
    this.name = name;
    this.dialCode = dialCode;
    this.code = code;
    this.dialCodeTitle = `(${this.dialCode})`;
  }
}